import { VERSE, FLORAL_ACCENT } from "@/lib/eventConfig";
import useReveal from "@/hooks/useReveal";

export default function VerseSection() {
  const ref = useReveal();
  return (
    <section
      className="relative py-32 sm:py-40 px-6 overflow-hidden"
      data-testid="verse-section"
    >
      <div className="absolute inset-0 -z-10 bg-[#F2EFE9]" />

      <img
        src={FLORAL_ACCENT}
        alt=""
        aria-hidden="true"
        className="absolute -left-10 top-8 w-44 sm:w-64 opacity-40 floaty pointer-events-none"
      />
      <img
        src={FLORAL_ACCENT}
        alt=""
        aria-hidden="true"
        className="absolute -right-10 bottom-8 w-44 sm:w-64 opacity-30 floaty pointer-events-none rotate-180"
        style={{ animationDelay: "3s" }}
      />

      <div ref={ref} className="reveal relative max-w-3xl mx-auto text-center">
        <span className="font-serif-display text-[#8FA092] text-7xl leading-none block">“</span>
        <blockquote className="font-serif-display italic text-3xl sm:text-4xl md:text-5xl text-[#4A5346] leading-snug mt-2">
          {VERSE.text}
        </blockquote>
        <p className="label-eyebrow mt-10">{VERSE.attribution.replace(/^—\s*/, "")}</p>
      </div>
    </section>
  );
}
